<ion-grid class="ion-no-padding m-number-pad-container">
  <ion-row class="m-number-pad-container__first-row">
    <ion-col class="ion-no-padding first-col" size="8">
      <ion-row class="quantity-block">
        <ion-col *ngIf="enableAddOrSub" class="decrement ion-no-padding" (click)="decrementCount()">
          <ion-thumbnail>
            <ion-img [src]="subtractIcon"></ion-img>
          </ion-thumbnail>
        </ion-col>
        <ion-col class="ion-no-padding ion-text-center">
          <div class="quantity-block__wrapper">
            <div class="label">{{ heading | translate | titlecase }}</div>
            <div class="value">{{ displayValue }}</div>
          </div>
        </ion-col>
        <ion-col *ngIf="enableAddOrSub" class="increment ion-no-padding" (click)="incrementCount()">
          <ion-thumbnail>
            <ion-img [src]="addIcon"></ion-img>
          </ion-thumbnail>
        </ion-col>
      </ion-row>
    </ion-col>
    <ng-container *ngIf="!enableFractionButton; else fractionLayout">
      <ion-col *ngIf="enablePrevButton" size="4" class="ion-no-padding second-col" (click)="handlePrevClick()">
        <ion-row class="ion-justify-content-center">
          <ion-img [src]="leftArrowIcon" class="ion-padding-end"></ion-img>
          <div>
            {{ 'number_pad.prev' | translate }}
          </div>
        </ion-row>
      </ion-col>
    </ng-container>

    <ng-template #fractionLayout>
      <ion-col size="4" class="ion-no-padding second-col prev-next-col">
        <div *ngIf="enablePrevButton" class="prev-next-button" (click)="handlePrevClick()">
          <ion-img [src]="leftArrowIcon" class="ion-padding-end"></ion-img>
          {{ 'number_pad.prev' | translate }}
        </div>
        <div *ngIf="enableNextButton" class="prev-next-button" (click)="handleNextClick()">
          {{ 'common_components.next' | translate }}
          <ion-img [src]="rightArrowIcon" class="ion-padding-start"></ion-img>
        </div>
      </ion-col>
    </ng-template>
    <ion-col *ngIf="enableCancel" size="4" class="ion-no-padding second-col" (click)="handleCancel()">
      <ion-row class="ion-justify-content-center">
        <div>
          {{ 'common_components.cancel' | translate }}
        </div>
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row class="m-number-pad-container__second-row">
    <ion-col size="8" class="ion-no-padding first-col">
      <ion-row class="number-pad-first-row">
        <ion-col
          class="ion-no-padding number-value"
          size="4"
          *ngFor="let number of numberPadFirstLineNumbers"
          (click)="handleNumClick(number)"
        >
          <div>{{ number }}</div>
        </ion-col>
      </ion-row>
      <ion-row class="number-pad-second-row">
        <ion-col
          class="ion-no-padding number-value"
          size="4"
          *ngFor="let number of numberPadSecondLineNumbers"
          (click)="handleNumClick(number)"
        >
          <div>{{ number }}</div>
        </ion-col>
      </ion-row>
    </ion-col>
    <ng-container *ngIf="!enableFractionButton; else fractionButton">
      <ion-col *ngIf="enableNextButton" class="ion-no-padding second-col" size="4" (click)="handleNextClick()">
        <ion-row class="ion-justify-content-center">
          <div>
            {{ 'common_components.next' | translate }}
          </div>
          <ion-img [src]="rightArrowIcon" class="ion-padding-start"></ion-img>
        </ion-row>
      </ion-col>
    </ng-container>

    <ng-template #fractionButton>
      <ion-col class="ion-no-padding second-col" size="4" (click)="handleFractionButtonClick()">
        <ion-row class="ion-justify-content-center">
          <div>
            {{ 'common_components.fraction' | translate }}
          </div>
        </ion-row>
      </ion-col>
    </ng-template>
    <ion-col *ngIf="enableSave" class="ion-no-padding second-col" size="4" (click)="handleSave()">
      <ion-row class="ion-justify-content-center">
        <div>
          {{ 'common_components.save' | translate }}
        </div>
      </ion-row>
    </ion-col>
  </ion-row>
  <ion-row class="m-number-pad-container__third-row">
    <ion-col class="ion-no-padding first-col" size="8">
      <ion-row class="number-pad-third-row">
        <ion-col
          class="ion-no-padding number-value"
          size="4"
          *ngFor="let number of numberPadThirdLineNumbers"
          (click)="handleNumClick(number)"
        >
          <div>{{ number }}</div>
        </ion-col>
      </ion-row>
      <ion-row class="number-pad-fourth-row">
        <ion-col *ngIf="enableMinus" class="ion-no-padding number-value" size="4" (click)="minusClick()">
          <div>-</div>
        </ion-col>
        <ion-col
          size="{{ enableDecimal ? (enableMinus ? '4' : '8') : '12' }}"
          class="ion-no-padding number-value"
          (click)="handleNumClick(0)"
        >
          <div>0</div>
        </ion-col>
        <ion-col *ngIf="enableDecimal" class="ion-no-padding number-value" size="4" (click)="decimalClick()">
          <div>.</div>
        </ion-col>
      </ion-row>
    </ion-col>
    <ion-col size="4" class="ion-no-padding second-col" (click)="handleDeleteClick()">
      <div>
        <ion-img [src]="deleteIcon" class="ion-padding-bottom"></ion-img>
        <div>
          {{ 'common_components.del' | translate }}
        </div>
      </div>
    </ion-col>
  </ion-row>
</ion-grid>
